
import { LucideHeart } from 'lucide-react'
import { Link } from 'react-router-dom'

export const Footer = () => {
    return (
        <footer className="border-t border-border bg-background">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-7xl">
                <div className="flex flex-col gap-4 text-sm text-muted-foreground md:flex-row md:items-center md:justify-between">
                    <div className="flex flex-col gap-1 text-center md:text-left">
                        <p>© 2025 ProcessPipe, LLC. All rights reserved.</p>
                        <div className="flex items-center justify-center md:justify-start">
                            <span>Made with</span>
                            <LucideHeart className="mx-1 inline-block size-5 stroke-red-700 fill-red-700 align-middle" />
                            <span>in Sun Prairie, WI</span>
                        </div>
                    </div>
                    <nav className="flex items-center justify-center gap-6 md:justify-end">
                        <Link to="/privacy" className="hover:text-foreground transition-colors">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="hover:text-foreground transition-colors">
                            Terms of Service
                        </Link>
                    </nav>
                </div>
            </div>
        </footer>
    )
}

